import {
  CreateAngelInvestorFormFieldValues,
  CreateInstituitionalInvestorFieldValues,
  ExternalInvestorType,
  Investor
} from '../types';

const sortByKeyMap = {
  name: 'name',
  url: 'url',
  designation: 'designation',
  visibleInDeal: 'visible_in_deal'
};

const formatInvestors = (investors?: Investor[]) => {
  const investorsList = investors ? [...investors] : [];

  investorsList.sort((a, b) => {
    let x = a.order;
    let y = b.order;

    if (x > y) {
      return 1;
    }
    if (x < y) {
      return -1;
    }
    return 0;
  });

  const idSet = new Set(investorsList.map(obj => obj.order));
  if (investorsList.length !== idSet.size) {
    return investorsList.map((investor, idx) => ({
      id: investor.id,
      name: investor.name,
      designation: investor.designation || '',
      description: investor.description || '',
      url: investor.url || '',
      logoPath: investor.logo_path || '',
      userId: investor.user_id ?? '',
      type: investor.type,
      roundId: investor.round_id ?? '',
      visibleInDeal: investor.is_visible_in_deal ?? false,
      createdAt: investor.created_at,
      order: idx
    }));
  }
  return (
    investorsList?.map(investor => ({
      id: investor.id,
      name: investor.name,
      designation: investor.designation || '',
      description: investor.description || '',
      url: investor.url || '',
      logoPath: investor.logo_path || '',
      userId: investor.user_id ?? '',
      type: investor.type,
      roundId: investor.round_id ?? '',
      visibleInDeal: investor.is_visible_in_deal ?? false,
      createdAt: investor.created_at,
      order: investor.order
    })) || []
  );
};

const formatCreateUpdateAngelInvestorPayload = (
  data: CreateAngelInvestorFormFieldValues,
  roundId?: string
) => {
  return {
    name: data.angelInvestorName?.trim(),
    designation: data.angelInvestorDesignation?.trim() || null,
    description: data.angelInvestorDescription?.trim(),
    url: data.angelInvestorURL || null,
    logo_path: data.angelInvestorLogo?.path ?? '',
    user_id:
      roundId && data.angelInvestorUserId
        ? data.angelInvestorUserId
        : undefined,
    type: ExternalInvestorType.SuperAngelInvestor,
    round_id: roundId || undefined,
    is_visible_in_deal: data.angelInvestorVisibleInDeal ?? false,
    created_at: data.angelInvestorCreatedAt ?? '',
    order: data.angelInvestorOrder ?? 0
  };
};

const formatCreateUpdateInstitutionalInvestorPayload = (
  data: CreateInstituitionalInvestorFieldValues,
  roundId?: string
) => {
  return {
    name: data.instituitonalInvestorName?.trim(),
    designation: data.instituitionalInvestorDesignation,
    description: data.instituitonalInvestorDescription?.trim() || null,
    url: data.instituitonalInvestorURL ?? '',
    logo_path: data.instituitonalInvestorLogo?.path ?? '',
    user_id: data.instituitionalInvestorUserId
      ? data.instituitionalInvestorUserId
      : undefined,
    type: ExternalInvestorType.InstitutionalInvestor,
    round_id: roundId || undefined,
    is_visible_in_deal: data.instituitionalInvestorVisibleInDeal ?? false,
    created_at: data.instituitionalInvestorCreatedAt ?? '',
    order: data.instituitionalInvestorOrder ?? 0
  };
};

export {
  sortByKeyMap,
  formatInvestors,
  formatCreateUpdateAngelInvestorPayload,
  formatCreateUpdateInstitutionalInvestorPayload
};
